import { Route } from "react-router-dom";
import { ApprovalRequestsPage } from "@/v2/pages/approval-requests/ApprovalRequestsPage";

export const approvalRequestsUris = {
  root: "approval-requests",
};

export const approvalRequestsRoutes = (
  <Route
    path={approvalRequestsUris.root}
    element={<ApprovalRequestsPage />}
  />
);
